<template>
  <div class="chart-container w-100">
    <apexchart v-if="chartData && chartData.length"
               ref="turnoverChart"
               type="bar"
               :height="350"
               :options="chartOptions"
               :series="formattedSeries">
    </apexchart>
  </div>
</template>

<script>
export default {
  name: 'HiresLeaversChart',
  props: {
    chartData: {
      type: Array,
      required: true
    },
    companyPrimaryColor: {
      type: String,
      default: '#00875A'
    }
  },
  computed: {
    formattedSeries() {
      let chartData = [];

      if(this.chartData) {
        chartData = [{
          name: 'New Hires',
          data: this.chartData.map(item => ({
            x: item.month_label,
            y: item.new_hires,
            dataLabelPrefix: '+'
          }))
        },{
          name: 'Leavers',
          data: this.chartData.map(item => ({
            x: item.month_label,
            y: -item.leavers,
            dataLabelPrefix: '-'
          }))
        }];
      }
    
      return chartData;
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          animations: {
            initialAnimation: { enabled: true },
            speed: 200
          },
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif',
          parentHeightOffset: 0
        },       
        theme: {
          monochrome: {
            enabled: true,
            shadeTo: 'light',
            shadeIntensity: 0.8,            
            color: this.companyPrimaryColor,
          }
        },         
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '70%',
            borderRadius: 0,
            radiusOnLastStackedBar: false,
            dataLabels: {
              position: 'center'
            }
          }
        },
        states: {
          hover: {
            filter: {
              type: 'darken',
              value: 0.9
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            const prefix = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].dataLabelPrefix
            return prefix + Math.abs(val)
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'          
        },
        xaxis: {
          type: 'category',
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          labels: {
            formatter: function(val) {
              return Math.abs(val)
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function(val) {
              return Math.abs(val)
            }
          }
        }
      }
    }
  },
  watch: {
    chartData: {
      handler(newVal) {
        if (newVal && newVal.length && this.$refs.turnoverChart) {
          this.$refs.turnoverChart.updateSeries(this.formattedSeries)
        }
      },
      deep: true
    }
  }
}
</script>